// extracted by mini-css-extract-plugin
export default {"wrapper":"notfound_wrapper__Oq19V","title":"notfound_title__e69fE","text":"notfound_text__Tm72-","button":"notfound_button__EOmrF"};